if (!window.console ||
    (window.console && typeof(window.console.log) !== 'function')) {
  window.console = {
    log: function() {},
    warn: function() {}
  };
}